import _ from 'lodash'
import config from '@/config'
import store from '@/store'
import { app } from '@/main'
import { SYSTEM_API_GET_AUTH } from '@/service/api/systemApi'
export const getConfig = function () {
  return {
    authType: '',
  }
}
/** request相关 */

export const getBaseUrl = function (req) {
  if (req.url === SYSTEM_API_GET_AUTH) {
    return ''
  }
  return `${config.baseURL}`
}

export const getAuth = function () {
  const { accessToken, refreshToken } = store.state.user.auth
  return {
    accessToken,
    refreshToken,
  }
}
/** 错误展示/进度条/loading */

export const showError = function (axiosError) {
  app.$message.error(axiosError.message)
}

export const showLoading = function () {
  // app.$loading.show()
}
export const hideLoading = function () {
  // app.$loading.hide()
}

export const showProgress = function () {
  app.$progress.start()
}
// success  true表示 请求正常并进度条结束。false 表示请求异常并进度条结束
export const hideProgress = function (success = true) {
  app.$progress.done()
}
/** response相关 */

export const validResponse = function (res) {
  return res.data.success === true
}
// 根据resData展示错误信息
export const getErrorMessage = function (res) {
  if (res.data) {
    if (res.data.description) {
      return res.data.description
    }
    if (res.data.message) {
      return res.data.message
    }
  }
  return ''
}

/** 额外处理，一般不用 */

export const extraRequestHandle = function (req) {
  const { accessToken } = getAuth()
  req.headers['accessToken'] = accessToken
  return req
}
export const extraResponseHandle = function (res) {
  return res
}
export const extraErrorHandle = function (error) {
  const details = {
    message: error.message,
  }
  for (const i in error) {
    details[i] = error[i]
  }
  console.info('ERROR', details)
  return error
}
/** 刷新token和登出相关 */

export const is401 = function (error) {
  // 网关校验的code和业务系统校验的code
  console.log(error)
  return error.data?.code === '401'
}
export const doRefreshToken = function () {
  // RefreshToken需要完成token的更新
  return store.dispatch('RefreshToken')
}
export const doLogout = _.throttle(
  function (e) {
    if (e.exceptionCode === 'E_REFRESH_FAIL') {
      showError({ message: '刷新token失败，请重新登陆' })
    }
    if (e.exceptionCode === 'E_NO_REFRESHTOKEN') {
      showError({ message: 'token已过期，请重新登陆' })
    }
    return store.dispatch('Logout')
  },
  1000,
  { trailing: false }
)
